export default {
    h5: {
        organizationPermission:
            "/gateway/huilianCust/businessPermissioncs/organizationPermission", //企业认证
        getPersonalFaceCaUrl:
            "/gateway/huilianCust/realCustcs/getPersonalFaceCaUrl", //刷脸认证
        queryCustomerInfo: "/gateway/huilianCust/logincs/queryCustomerInfo", //客户信息
    },
    wechat: {
        organizationPermission:
            "/gateway/huilianCust/businessPermissioncs/organizationPermission", //企业认证
        getPersonalFaceCaUrl:
            "/gateway/huilianCust/realCustcs/getPersonalFaceCaUrl", //刷脸认证
    },
};



// WEBPACK FOOTER //
// ./src/authCertificateCompact/ACEnterprosePapers/api.js